import { getRailsFormClient } from "../client";

export interface SubmitFeedbackParams {
  details: string;
  feedbackType: string;
  questionId?: string;
  file?: File | null;
}

// Submits user feedback
export const submitFeedback = async ({
  details,
  feedbackType,
  questionId,
  file,
}: SubmitFeedbackParams) => {
  const Route = `/api/internal_api/v1/feedbacks`;

  const formData = new FormData();
  formData.append("details", details);
  formData.append("need_improve", feedbackType);

  if (questionId) {
    formData.append("question_id", questionId);
  }

  if (file) {
    formData.append("file", file, file.name || "image.png");
  }

  const client = getRailsFormClient();
  const { data } = await client.post(Route, formData);
  return data;
};
